const AnswerSelection = ({ question, answer, handleAnswer }) => {
  console.log('Full answer object:', answer);
  console.log('answer.id type:', typeof answer?.id);
  console.log('answer.id value:', answer?.id);
    
  return (
    <div className="question-options">
      {question.answerChoices
      .sort((a, b) => a.order - b.order)
      .map((choice, index) => {
        const isChecked = answer ? answer.id === choice.id : false;
        console.log(`Choice ${choice.id}: isChecked=${isChecked}, answer.id=${answer?.id}, choice.id=${choice.id}`);
        return (
          <label key={index} className="answer-choice-label">
            <input
              type="radio"
              name={`answer-${question.id}`}
              checked={isChecked}
              onChange={() => {
                console.log(`Selected choice ${choice.id} for question ${question.id}`);
                handleAnswer(question, choice)
              }}
              className="answer-choice-radio"
              title={choice.explanatory_text || ""}
            />
            <span className="answer-choice-text">{choice.text}</span>
          </label>
        );
      })}
    </div>
  );
};

export default AnswerSelection;